import { c, classy } from '@onfido/castor';
import { useField } from '@onfido/castor-react';
import React from 'react';
import { withRef } from '../../utils';
export const Fieldset = withRef(function Fieldset({ className, ...restProps }, ref) {
    const { disabled } = useField();
    return (React.createElement("fieldset", { disabled: disabled, ...restProps, ref: ref, className: classy(c('fieldset'), className) }));
});
//# sourceMappingURL=fieldset.js.map